import React from 'react';
import {
    Button, Modal, ModalHeader, ModalFooter, ModalBody, Card, CardBody, Progress
} from 'reactstrap';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
//react-redux comm
import { connect } from 'react-redux';
import {appHelpers, store} from '../../_helpers';
import SearchPanel from './search_panel';
import PaginatedResult from './records';

// styling
import './style.css';

import {alertActions, apiActions, commonActions, modalActions} from '../../_actions';
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";

import {commonService} from "../../_services";
import RejectIcon from 'react-icons/lib/md/cancel';
import CheckIcon from 'react-icons/lib/md/check-circle';
import ViewTemplate from "./viewTemplate";
import {appConstants} from "../../_constants";

const Categories = [
	{ Id: 1, Name: 'Status'},
	{ Id: 2, Name: 'Entities'},
    /*This should be catered for but the API is not supporting it at the moment*/
	// { Id_: 3, Name: 'Created By'},
];

const CreatedByCat = [
    { Name: "Everyone", Id_: "CB1", type: 3 },
    { Name: "Me", Id_: "CB2" , type: 3 }
];

const StatusCat = [
    { Name: "All", Id_: -1, type: 1 },
    { Name: "Pending", Id_: appConstants.MAKER_CHECKER_STATUS.PENDING, type: 1 },
    { Name: "Approved", Id_: appConstants.MAKER_CHECKER_STATUS.APPROVED, type: 1 },
    { Name: "Rejected", Id_: appConstants.MAKER_CHECKER_STATUS.REJECTED, type: 1 }
];

const ViewHeader = () => (
    <div className="view-header d-flex align-items-center">
        <header className="text-white">
            <h1 className="h5 title text-uppercase">Maker Checker</h1>
            <p className="mb-0 subtitle text-nowrap">Approval page for maker checker records</p>
        </header>
    </div>
);

const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class MakerChecker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().subtract(1, 'month'),
            endDate: new Date(),
            filterModes: Categories,
            currentFilterParameter: {},
            selectedFilterMode: 1,
            searchOptions: [],
            filterValues: [{ Name: "All", Id_: -1, type: 1 }],
            filterValueKey: '',
            filterLabelKey: '',
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            //Notification
            notification: {
            // title: 'Default Title',
            message: 'Default Message',
            level: 'success',
            dismissible: true,
            },
            records: false,
            pageSize: 10,
            currentPage: 1,
            contentErrorText:false,
            openModal: false,
            TotalCount: 0,
            PayloadViewTemplate: false,
            ActiveRecord: false,
            Comment: '',
            Entities: []
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        //    Fetch Airlines
        const reduxState = store.getState();
        const { dispatch} = this.props;

        if (!reduxState.entities) {
            dispatch(commonActions.getEntities())
        }else{
            this.prepareEntities(reduxState.entities)
        }

        // Set default Category selection
        this.updateCatValue({ Name: 'Status', Id: 1 });
        this.handleCatChange({ Name: 'Status', Id: 1 });

        this.search(null);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { entities } = nextProps;
        if(entities)
            this.prepareEntities(entities);
    }

    prepareEntities = (entities) => {
     const preparedEntities =  entities.map(function(item){
          return  {
              type: 2,
              Id_ : item.EntityTypeId,
              Name : item.EntityType,
              ...item
          }
      }) ;
     this.setState({ Entities: preparedEntities})
    };

    //update selected category
    updateCatValue = (newValue) => {
		this.setState({
            selectedFilterMode: newValue.Id
        });
        this.handleCatChange(newValue);
    }

    //populate the multi search options with appropriate category options
    handleCatChange = (option) => {
        if (option) {// incase all category options are remove
            switch (option.Id) {
                case 2:
                    return this.setState({
                        filterOptions: this.state.Entities,
                        filterLabelKey: 'Id_',
                        filterValueKey: 'Name',
                    });
                case 3:
                    return this.setState({
                        filterOptions: CreatedByCat,
                        filterLabelKey: 'Id_',
                        filterValueKey: 'Name',
                    });
                case 1:
                    return this.setState({
                        filterOptions: StatusCat,
                        filterLabelKey: 'Id_',
                        filterValueKey: 'Name',
                    });
                default:
                  return this.state;
              }
        }
        return this.setState({ searchOptions: [] });
    }

    // remove option if option in that category is already selected
    switchOptionsPerCategory = (currentArray, newArray, category) => {
        const { selectValue } = this.state;
        let currentCat = (category)? category : selectValue;

        let optionToReplace = currentArray.filter(option => option.cat === currentCat.value)[0];

        if (optionToReplace) {
            return newArray.filter(option => option.label !== optionToReplace.label);
        } else {
            return newArray;
        }
    }

    //update selected options categories
    handleSelectChange = (newValue, category) => {
        let currentArray = this.state.searchArray;
        //debugger;
        let newArray = (currentArray.length > 0) ? this.switchOptionsPerCategory(this.state.searchArray, newValue, category) : newValue;
        this.setState({ searchArray: newArray });
    }

    handleSelectedFilterValuesChange = (target) => {
        let currFilterValues = this.state.filterValues;
        let newValue = target.filter(x => !currFilterValues.includes(x));
        let removedValue = currFilterValues.filter(x => !target.includes(x));
        if(removedValue.length === 0){
            let found = false;
            currFilterValues.forEach(function (item, key) {
                if(item.type === newValue[0].type){
                    currFilterValues[key] = newValue[0];
                    found = true;
                }
            });
            if(!found){
                currFilterValues = target;
            }
            this.setState({filterValues: currFilterValues});
        }else{
            this.setState({filterValues: target});
        }
    };

    formatAirlines = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'AirlineId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    formatSearchParameters = (res) => {
        const { filterValues } = this.state;
        const { userName, userRole } = this.props.authentication.user;
        let params = {
            UserName: userName
        };

        let StatusId = false; let EntityTypeId = false;
        filterValues.forEach(item => {
            if(item.type === 1 && item.Id_ !== -1){
                StatusId = item.Id_
            } else if(item.type === 2){
                EntityTypeId = item.Id_
            }
        });
        if(StatusId !== false) params.StatusId = StatusId;
        if(EntityTypeId !== false) params.EntityTypeId = EntityTypeId;
        return {
            AppId: appConstants.MAKER_CHECKER_APP_ID,
            RoleName: userRole,
            ...params
        };

    }

    formatDestinationAirports= (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'DestinationAirportId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    formatDepartureAirports= (res) => {
        let data = [];
        for (let item of res) {
            item['cat'] = 'DepartureAirportId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    resetError() {
        this.props.dispatch(modalActions.clear());
    }

    toggleModal = () => {
        this.setState({ openModal: !this.state.openModal, Comment: ""});
    };

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    handApprovalModal = (ActiveRecord) => {
        const PayloadViewTemplate = JSON.parse(ActiveRecord.PayloadViewTemplate);
        this.setState({ ActiveRecord, PayloadViewTemplate, openModal: !this.state.openModal});
    };

    handleApproval = (status) => {
        const  { Comment, ActiveRecord } = this.state;
        const { dispatch, authentication } = this.props;

        if(Comment === ""){
            this.setState({ErrorMessage: "Please provide a comment"})
        }else{
            dispatch(apiActions.startRequest());
            const payload = {
                MakeCheckerId: ActiveRecord.Id,
                UserName: authentication.user.userName,
                Comment
            };

            let requestHTTP = (status === appConstants.MAKER_CHECKER_STATUS.APPROVED) ? commonService.approveMakerChecker(payload) : commonService.rejectMakerChecker(payload);
            requestHTTP.then(res => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    const successMessage = (status === appConstants.MAKER_CHECKER_STATUS.APPROVED) ? "Record approved successfully" : "Record rejected successfully";
                    this.notify(successMessage, appConstants.NOTIFY_SUCCESS);
                    this.toggleModal();
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(appHelpers.interpretErrorResponseAlt2(res.response), appConstants.NOTIFY_ERROR));
                    dispatch(apiActions.endRequest());
                }
                /* Fetch updated records */
                this.search(this.state.currentPage);
            }).catch(err => {
                dispatch(alertActions.error(appHelpers.interpretErrorResponseAlt2(err), appConstants.NOTIFY_ERROR));
                dispatch(apiActions.endRequest());

            });


        }
    };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    search = async (pageNumber) => {
        const { dispatch } = this.props;
        const { searchArray, pageSize } = this.state;
        this.setState({contentError: false});
        if(pageNumber === null){
            dispatch(apiActions.startFullPageRequest());
            pageNumber = 1;
        }else{
            dispatch(apiActions.startRequest());
        }

        let searchParams = this.formatSearchParameters(searchArray);

        let payload__ = {
            "PageSize": pageSize,
            "From": pageNumber,
            ...searchParams
        };

        commonService.searchMakerChecker(payload__)
        .then(res => {
            if(res.status === appConstants.SUCCESS_RESPONSE) {
                const { TotalCount, MakeCheck } = res.response;
                this.setState({ currentPage: pageNumber, records: MakeCheck, TotalCount});
                dispatch(apiActions.endRequest());
            }
            else if(res.status === appConstants.ERROR_RESPONSE){
                dispatch(alertActions.error(appHelpers.interpretErrorResponseAlt2(res.response)));
                dispatch(apiActions.endRequest());
            }
        }).catch(err => {
            dispatch(alertActions.error(appHelpers.interpretErrorResponseAlt2(err)));
            dispatch(apiActions.endRequest());

        })
    };

    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }
    render() {
        const {contentErrorText, filterModes, selectedFilterMode, filterOptions, filterLabelKey, filterValues, filterValueKey,
            openModal, ActiveRecord, Comment, contentError, currentPage, pageSize, records, TotalCount, PayloadViewTemplate
        } = this.state;
        const { requesting, pageRequesting } = this.props;

        return (
            <div className="view">
                <ViewHeader/>
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress striped animated color="success" value={100} className="mb-2"/> }
                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                        <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}

                        { (!contentError && !pageRequesting) &&
                        <CardBody>
                            <h6 className="mb-4 text-uppercase">Search Panel</h6>
                            <SearchPanel
                                contentErrorText={contentErrorText}
                                categories={filterModes}
                                selectedFilterMode={selectedFilterMode}
                                filterOptions={filterOptions}
                                filterLabelKey={filterLabelKey}
                                filterValueKey={filterValueKey}
                                filterValues={filterValues}
                                onFilterModeValueChange={this.updateCatValue}
                                onSelectedFilterValuesChange={this.handleSelectedFilterValuesChange}
                                onSearch={this.search}
                                startDateChange={startDate => this.setState({ startDate })}
                                endDateChange={endDate => this.setState({ endDate })} />

                            <CardBody>

                                {(!pageRequesting && records) &&
                                <div>
                                    <PaginatedResult
                                        records={records}
                                        currentPage={currentPage}
                                        navigate={this.search}
                                        pageSize={pageSize}
                                        totalCount={TotalCount}
                                        handApprovalModal={this.handApprovalModal}
                                    />
                                </div>
                                }
                                {(!pageRequesting && !records) &&
                                <PageEmptyContent message='No record match your search!'/>
                                }

                                <Modal size={'lg'} isOpen={openModal} toggle={this.toggleModal} className={this.state.modalClass}>
                                    <ModalHeader toggle={this.toggleModal}>Approval Form</ModalHeader>
                                    <ModalBody>

                                     <ViewTemplate record={ActiveRecord} Comment={Comment} handleChange={this.handleChange} payload={PayloadViewTemplate}/>

                                    </ModalBody>
                                    <ModalFooter>
                                        {
                                            (ActiveRecord &&
                                                ActiveRecord.StatusId === appConstants.MAKER_CHECKER_STATUS.PENDING &&
                                                ActiveRecord.CreatedBy === this.props.authentication.user.userName
                                            ) &&
                                            <h6 className={'text-muted'}>
                                                Record is pending!
                                            </h6>
                                        }
                                        {
                                            (ActiveRecord &&
                                                ActiveRecord.StatusId === appConstants.MAKER_CHECKER_STATUS.PENDING &&
                                                ActiveRecord.CreatedBy !== this.props.authentication.user.userName
                                            ) &&
                                                <span>
                                                     <Button className="btn-avi-primary" disabled={!Comment}  onClick = {(e)=>this.handleApproval(appConstants.MAKER_CHECKER_STATUS.APPROVED)}>
                                                       <CheckIcon/> Approve
                                                    </Button>
                                                    &nbsp;
                                                    <Button color="danger" disabled={!Comment}  onClick = {(e)=>this.handleApproval(appConstants.MAKER_CHECKER_STATUS.REJECTED)}>
                                                      &nbsp;&nbsp;<RejectIcon/> Reject&nbsp;&nbsp;
                                                    </Button>
                                                </span>
                                        }
                                        {/*Approved Record*/}
                                        {
                                            (ActiveRecord && ActiveRecord.StatusId === appConstants.MAKER_CHECKER_STATUS.APPROVED) &&
                                            <h6 className={'text-avi-primary'}>
                                                Record Approved by {ActiveRecord.ApprovedBy}
                                            </h6>

                                        }
                                        {/*Rejected Record*/}
                                        {
                                            (ActiveRecord && ActiveRecord.StatusId === appConstants.MAKER_CHECKER_STATUS.REJECTED) &&
                                                <h6 className={'text-danger'}>
                                                    Record Rejected by {ActiveRecord.ApprovedBy}
                                                </h6>

                                        }

                                    </ModalFooter>
                                </Modal>
                            </CardBody>
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {
        airlinesCarriers: state.airlinesCarriers,
        desAirports: state.desAirports,
        depAirports: state.depAirports,
        requesting: state.api.requesting,
        pageRequesting: state.api.pageRequesting,
        modal: state.modal,
        entities: state.entities,
        authentication: state.authentication
    };
}

export default connect(mapStateToProps)(MakerChecker);



// WEBPACK FOOTER //
// ./src/views/makerChecker/index.js